import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card } from '../components/ui/Card'
import { Button } from '../components/ui/Button'
import { SectionLabel } from '../components/ui/SectionLabel'
import { ModeratorMessageDialog } from '../components/messaging/ModeratorMessageDialog'
import { ABOUT_MISSION, ABOUT_PILLARS, ABOUT_STEPS, ABOUT_FAQ } from '../lib/safetyContent'

/** About & help (COTC_SafetyKudos R4 / DESIGN §3.17). */
export function AboutPage() {
  const navigate = useNavigate()
  const [moderatorOpen, setModeratorOpen] = useState(false)

  return (
    <div className="animate-rise px-4 py-6 sm:px-10 sm:py-9">
      <div className="font-mono text-[12px] uppercase tracking-label text-ink-fainter">About &amp; help</div>
      <h1 className="mt-2 font-serif text-[32px] font-medium leading-tight tracking-[-.015em] text-ink">Good games happen in small rooms.</h1>
      <div className="mt-4 max-w-[64ch] space-y-3">
        {ABOUT_MISSION.map((p, i) => (
          <p key={i} className="text-[15px] leading-relaxed text-ink-muted">{p}</p>
        ))}
      </div>

      <div className="mt-9 grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(min(100%,240px),1fr))]">
        {ABOUT_PILLARS.map((p) => (
          <Card key={p.n} tone="panel">
            <span className="font-mono text-[13px] text-terra">{p.n}</span>
            <div className="mt-2 text-[14px] font-medium text-ink">{p.title}</div>
            <p className="mt-1 text-[13px] leading-relaxed text-ink-muted">{p.body}</p>
          </Card>
        ))}
      </div>

      <h2 className="mt-11 font-serif text-[22px] font-medium text-ink">How it works</h2>
      <ol className="mt-4 space-y-3">
        {ABOUT_STEPS.map((s, i) => (
          <li key={i} className="flex gap-4">
            <span className="font-mono text-[13px] text-terra">{String(i + 1).padStart(2, '0')}</span>
            <div>
              <div className="text-[14px] font-medium text-ink">{s.title}</div>
              <p className="mt-0.5 text-[13px] leading-relaxed text-ink-muted">{s.body}</p>
            </div>
          </li>
        ))}
      </ol>

      <h2 className="mt-11 font-serif text-[22px] font-medium text-ink">Questions parents ask</h2>
      <div className="mt-4 space-y-4">
        {ABOUT_FAQ.map((f, i) => (
          <div key={i}>
            <div className="text-[14px] font-semibold text-ink">{f.q}</div>
            <p className="mt-1 max-w-[64ch] text-[13px] leading-relaxed text-ink-muted">{f.a}</p>
          </div>
        ))}
      </div>

      <Card tone="panel" className="mt-10">
        <SectionLabel>Talk to a human</SectionLabel>
        <p className="mt-2 text-[13.5px] leading-relaxed text-ink-muted">
          Send a message to the moderator review queue. This is not an emergency channel, and no response time or continuous staffing is promised.
        </p>
        <div className="mt-4 flex flex-wrap gap-3">
          <Button variant="ink" onClick={() => setModeratorOpen(true)}>Message a moderator</Button>
          <Button variant="outline" onClick={() => navigate('/rules')}>Read the kindness code</Button>
        </div>
      </Card>

      <ModeratorMessageDialog open={moderatorOpen} onClose={() => setModeratorOpen(false)} />
    </div>
  )
}
